import { GOAL_TIER_IDS, MAX_GOALS_PROFILE } from '../constants/goalTiers';

const TIER_LABELS = {
  essential: 'Objetivos essenciais',
  support: 'Objetivos de suporte',
  context: 'Contexto de treino',
};

function formatSlugLine(item) {
  if (!item) return '';
  const desc = (item.description || '').slice(0, 80);
  return desc ? `- ${item.label}: ${desc}` : `- ${item.label}`;
}

export function formatGoalsPromptPreview(tiers, lookup = {}) {
  const total = GOAL_TIER_IDS.reduce((sum, id) => sum + (tiers?.[id]?.length || 0), 0);
  if (!total) {
    return 'Objetivos selecionados: não informados (assuma hipertrofia e saúde geral).';
  }

  const blocks = [`Objetivos selecionados pelo usuário (${total}/${MAX_GOALS_PROFILE}):`];
  for (const tierId of GOAL_TIER_IDS) {
    const slugs = tiers?.[tierId] || [];
    if (!slugs.length) continue;
    blocks.push(`${TIER_LABELS[tierId]} (${slugs.length}/${MAX_GOALS_PROFILE}):`);
    blocks.push(...slugs.map((slug) => formatSlugLine(lookup[slug])));
  }
  blocks.push(
    'Priorize coerência entre esses objetivos ao montar o treino. Essenciais têm peso maior na montagem do plano. Use português brasileiro nos nomes de exercícios e nas notas.'
  );
  return blocks.filter(Boolean).join('\n');
}
